/* ==========================================================================
   Orvo — cart-upsell.js
   "Frequently bought together" row in the cart drawer, on every page.

   The drawer (snippets/cart-drawer.liquid) and its renderer (theme.js) stay
   untouched: this file adds one slot directly under the cart lines and
   fills it from sections/cart-upsell.liquid via Shopify's Product
   Recommendations API, for the product added last (cart.js lists it first).

   It only fetches while the drawer is open, so a page view costs nothing,
   and refreshes when the cart lines change (theme.js rewrites them after
   every add, quantity change or removal). Each card links to its product
   page, where the customer picks size, length or colour.
   ========================================================================== */
(function () {
  'use strict';

  var drawer = document.querySelector('.cart-drawer');
  if (!drawer) return;
  var itemsEl = drawer.querySelector('.cart-drawer__items');
  var footEl = drawer.querySelector('.cart-drawer__foot');
  if (!itemsEl || !footEl) return;

  var ROOT = (((window.Orvo || {}).routes || {}).root) || '/';
  if (ROOT.charAt(ROOT.length - 1) !== '/') ROOT += '/';

  // The row lives at the end of the cart lines, so it sits right under them
  // and scrolls with them. theme.js rewrites the lines' HTML on every change,
  // which drops the row; place() puts the same element (and its contents) back.
  var slot = document.createElement('div');
  slot.className = 'cu';
  slot.hidden = true;
  function place() {
    if (!itemsEl.querySelector('.cart-line')) return;
    if (slot.parentNode !== itemsEl || itemsEl.lastElementChild !== slot) itemsEl.appendChild(slot);
  }
  place();

  var lastKey = null;
  var pending = null;

  function isOpen() { return drawer.classList.contains('is-open'); }

  // Short product name for the sub line: "Nödradio 10 000 mAh – powerbank …" → "Nödradio 10 000 mAh".
  function shortName(title) {
    var t = (title || '').trim();
    var cut = t.split(/\s[–—-]\s/)[0];
    return cut.length > 2 ? cut : t;
  }

  function refresh() {
    var lines = itemsEl.querySelectorAll('.cart-line');
    if (!lines.length) { slot.hidden = true; slot.innerHTML = ''; lastKey = null; return; }
    var first = lines[0];
    var pid = first.getAttribute('data-product-id');
    if (!pid) return;
    var ids = Array.prototype.map.call(lines, function (l) { return l.getAttribute('data-product-id'); }).join(',');
    var key = pid + '|' + ids;
    if (key === lastKey) return;
    lastKey = key;

    var titleEl = first.querySelector('.cart-line__title');
    var name = shortName(titleEl ? titleEl.textContent : '');
    var url = ROOT + 'recommendations/products?section_id=cart-upsell&limit=10&intent=related&product_id=' + encodeURIComponent(pid);
    var req = pending = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (txt) {
        if (req !== pending) return; // a newer refresh won
        var tmp = document.createElement('div');
        tmp.innerHTML = txt;
        var found = tmp.querySelector('[data-cu]');
        if (!found || !found.querySelector('.cu-card')) { slot.hidden = true; slot.innerHTML = ''; return; }
        slot.innerHTML = found.innerHTML;
        Array.prototype.forEach.call(slot.querySelectorAll('[data-cu-name]'), function (b) { b.textContent = name; });
        slot.hidden = false;
        edges();
      })
      .catch(function () { slot.hidden = true; });
  }

  // Arrows only when the row actually scrolls; dimmed at either end.
  function edges() {
    var rail = slot.querySelector('[data-cu-rail]');
    if (!rail) return;
    var slack = rail.scrollWidth - rail.clientWidth;
    slot.classList.toggle('cu--scrolls', slack > 4);
    var prev = slot.querySelector('[data-cu-prev]');
    var next = slot.querySelector('[data-cu-next]');
    if (prev) prev.disabled = rail.scrollLeft <= 2;
    if (next) next.disabled = rail.scrollLeft >= slack - 2;
  }
  slot.addEventListener('scroll', edges, true);
  window.addEventListener('resize', edges, { passive: true });

  slot.addEventListener('click', function (e) {
    var rail = slot.querySelector('[data-cu-rail]');
    var arrow = e.target.closest('[data-cu-prev], [data-cu-next]');
    if (arrow && rail) {
      var step = rail.clientWidth * 0.8 * (arrow.hasAttribute('data-cu-prev') ? -1 : 1);
      rail.scrollBy({ left: step, behavior: 'smooth' });
    }
    // Cards are plain links to the product page; the browser handles them.
  });

  // Cart lines rewritten by theme.js → put the row back under them, then
  // refresh if the drawer is open, else mark stale. Re-appending the row is
  // itself a change here; place() and refresh() are no-ops the second time.
  new MutationObserver(function () {
    place();
    if (isOpen()) refresh(); else lastKey = null;
  }).observe(itemsEl, { childList: true });

  // Drawer opened → fill the row (once per cart state).
  new MutationObserver(function () {
    if (isOpen()) refresh();
  }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

  if (isOpen()) refresh();
})();
